"use client";

import React from "react";
import { ArrowRight, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StrategicAnalystProfile() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="176222" id="government-backed-10-yield-property-investments" className="dark bg-background relative w-full overflow-hidden py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-8">
          
          {}
          <div ref={textRef} className={`flex flex-col gap-6 lg:col-span-7 transition-all duration-1000 ease-out ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <h1 className="text-foreground font-default text-4xl font-bold leading-tight tracking-tight md:text-[40px] lg:text-6xl lg:leading-[1.1]">
              Government Backed <span className="text-primary">10% Yield</span> Property Investments
            </h1>
            
            <p className="text-muted-foreground font-default max-w-[600px] text-lg md:text-[20px] leading-relaxed">
              Secure long-term income through UK social housing. Asset-backed security with 10-year government-funded leases and significant social impact.
            </p>
            
            <div className="mt-4 flex flex-col gap-4 sm:flex-row sm:items-center">
              <Button asChild className="bg-primary hover:bg-primary/90 h-12 px-8 text-[16px] font-bold text-primary-foreground shadow-lg transition-transform hover:-translate-y-0.5">
                <Link to="https://10percent-yield.com/contact/">
                  Get Investment Pack
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              
              <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary/10 h-12 px-8 text-[16px] font-bold shadow-sm transition-transform hover:-translate-y-0.5">
                <Link to="https://10percent-yield.com/contact/">
                  <Mail className="mr-2 size-5" />
                  Book a Call
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imgRef} className={`relative mx-auto w-full max-w-md lg:col-span-5 lg:ml-auto transition-all duration-1000 delay-200 ease-out ${isImgVisible ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}`}>
            <div className="relative aspect-[4/5] w-full">
              {}
              <div className="absolute -inset-8 -z-20 rounded-2xl opacity-20" style={{
              backgroundImage: "radial-gradient(var(--color-primary) 2px, transparent 2px)",
              backgroundSize: "24px 24px"
            }} aria-hidden="true" />
              
              {}
              <div className="border-primary/30 absolute inset-0 -z-10 translate-x-5 translate-y-5 rounded-xl border-2" aria-hidden="true" />
              
              {}
              <div className="bg-muted relative h-full w-full overflow-hidden rounded-xl shadow-2xl backdrop-blur-sm">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/uk-social-housing-investment.png" alt="Modern UK Social Housing Architecture" className="h-full w-full object-cover object-center grayscale-[20%] hover:grayscale-0 transition-all duration-700" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}